import React, {forwardRef} from 'react'
import {DropdownTheme, Dropdown as TPADropdown} from 'wix-ui-tpa/cssVars'
import type {DropdownProps as TPADropdownProps, DropdownInputHandle} from 'wix-ui-tpa/cssVars'

import {st, classes} from './styles.st.css'

export const Dropdown = forwardRef<DropdownInputHandle, TPADropdownProps>(
  ({className, theme, ...rest}, ref) => {
    const dropdownThemeClass = theme === DropdownTheme.Box ? classes.box : classes.line
    return (
      <TPADropdown
        ref={ref}
        className={st(className, classes.dropdown, dropdownThemeClass)}
        theme={theme}
        {...rest}
      />
    )
  },
)
